import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  selectInputButton: {
    '& .select-input__input:disabled': {
      opacity: 0.5
    },

    '& .select-input__input': {
      height: 32
    }
  },

  generalInformationContainer: {
    width: '100%',
    display: 'flex',
    gap: 16,

    '& .custom-input__input:disabled': {
      opacity: 0.5
    },

    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column'
    }
  },

  generalInformationForm: {
    width: '100%'
  },

  inputButton: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: 16
  },

  saveButton: {
    width: 48,
    height: 48,
    borderRadius: 4,
    backgroundColor: 'transparent',

    '& path': {
      color: theme.palette.primary.main
    }
  },

  input: {
    width: '100%',
    '& .custom-input__input': {
      height: 34
    }
  },

  editButton: {
    minWidth: '48px !important',
    width: '48px !important',
    height: '48px !important',
    borderRadius: '4px !important'
  },

  genealogicalButtonContainer: {
    width: '100%',
    display: 'flex',
    gap: 16,
    justifyContent: 'space-between',

    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',

      '& button': {
        width: '100%'
      }
    }
  },

  sectionName: {
    fontSize: 18,
    fontWeight: 500,
    marginBottom: -10
  },

  generalFamilyInformationForm: {
    marginTop: -10,
    width: '100%',
    gap: 16
  },

  genealogicalButton: {
    width: 'max-content',
    backgroundColor: 'transparent',
    borderRadius: 4,
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main
  },

  actionButtons: {
    display: 'flex',
    gap: 16,

    [theme.breakpoints.down('xs')]: {
      width: '100%',
      '& button': {
        width: '100%'
      }
    }
  }
}))
